export const surveyForm = {
    thankyoumessage: "Thank you for submitting Your Survey!",
    contributionMessage: "Your contribution means a lot for us so we can bring more improvements in future!",
    serviceQuality: "Service Quality",
    speedResponse: "Speed of Response on Changed Requests",
    compliance: "Compliance to Contractual Obligations",
    attentionDetail: "Attention to detail and thoroughness",
    definingRequests: "Understanding and Help with Defining Requests",
    financeDept: "Promptness and Cooperation of Administrative-Finance Department",
    priceTerms: "Price/Terms of Payments",
    complaintResolution: "Speed of Complaint Resolution",
    complaintWay: "Way of Resolving Complaints",
    importance: "Importance",
    score: "Score",
    suggestionsComments: "Suggestions / Comments",
    textFieldLabel: "Write your description here....",
    submit: "Submit",
    count: {
        count1: 1,
        count2: 2,
        count3: 3,
        count4: 4,
        count5: 5,
        count6: 6,
        count7: 7,
        count8: 8,
        count9: 9
    },
};